"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const publicodes_1 = require("publicodes");
const styled_components_1 = __importDefault(require("styled-components"));
const Explanation_1 = __importDefault(require("../Explanation"));
function RuleMecanism({ rawNode, explanation, title, virtualRule, }) {
    return (jsx_runtime_1.jsxs(Styled, { children: [jsx_runtime_1.jsx("span", Object.assign({ className: "ui__ small label" }, { children: publicodes_1.capitalise0(virtualRule ? rawNode.nom : title) }), void 0), jsx_runtime_1.jsx(Explanation_1.default, { node: explanation.valeur }, void 0)] }, void 0));
}
exports.default = RuleMecanism;
const Styled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	padding: 1rem;
	padding-top: 0rem;
	margin: 1rem 0;
	border: 1px solid var(--darkColor);
	border-radius: 3px;
	> .label {
		margin: 0 -1rem;
		margin-bottom: 1rem;
		border-radius: 0rem;
	}
`;
